import React from "react";
import styled from "styled-components";

export const ActionButton = ({
  onClick,
  disabled,
  ariaLabel,
  children,
  color = "#64748b",
  hoverColor = "#D52566",
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      $color={color}
      $hoverColor={hoverColor}
    >
      {children}
    </Button>
  );
};

const Button = styled.button`
  background: none;
  border: none;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  color: ${({ disabled, $color }) => (disabled ? "#CBD5E0" : $color)};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    scale: 1.3;
    color: ${({ disabled, $hoverColor }) =>
      disabled ? "#CBD5E0" : $hoverColor};
  }
`;
